const firebaseConfig = {
    apiKey: "AIzaSyBrAuYmXdhyTgkVHhKHo3IaFeQDxlTBMu4",
    authDomain: "assignment-macgh-10.firebaseapp.com",
    projectId: "assignment-macgh-10",
    storageBucket: "assignment-macgh-10.appspot.com",
    messagingSenderId: "1001965840287",
    appId: "1:1001965840287:web:b836d82be7496cacf5ffaa"
  };

  export default firebaseConfig;